import React from 'react';
import { IDefaultResponsiveSupport } from '../../../common/interfaces/common.interface';
import AiAssistantComponent from '../../../components/ai-assistant/ai-assistant.component';

interface AiAssistantProps extends IDefaultResponsiveSupport {}
const AiAssistant: React.FC<AiAssistantProps> = ({ responsiveMode }) => {
  return (
    <div style={{ padding: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <AiAssistantComponent responsiveMode={responsiveMode} osMode={true} />
    </div>
  );
};

export default AiAssistant;
